import { Warning } from '@mui/icons-material'
import { Box, Tooltip } from '@mui/material'

interface NodeErrorsProps {
  errors?: string[]
}

export function NodeErrors({ errors }: Readonly<NodeErrorsProps>) {
  return (
    <Box padding={1}>
      {errors && errors?.length > 0 && (
        <Tooltip
          arrow={true}
          placement="top-end"
          title={<div style={{ whiteSpace: 'pre-wrap' }}>{errors.join('\n')}</div>}
        >
          <Warning color="warning" />
        </Tooltip>
      )}
    </Box>
  )
}
